
import Loader from "../Loader/Loader"
import ReviewModerationItem from "./ReviewItem";
import ReviewFilters from "./ReviewFilters";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { GET_REVIEWS_DEFAULT_SIZE, REVIEW_PAGE_HEADERS } from "../../../utils/constants";
import { getReviews } from "../../../core/actionCreators/rmActionCreator";
import { useDispatch } from "react-redux";
import queryString from "query-string";
import CommonPagination from "../CommonPagination/CommonPagination";
import { removeEmptyStringKeys } from "../../../utils/helper";

const EMPTY_FILTERS = {
    id: "",
    productMsn: "",
    userId: "",
    reviewSubject: "",
    isApproved: "",
    isActive: "",
    fromDate: "",
    toDate: "",
};

const ReviewList = () => {
    const dispatch = useDispatch()
    let { reviews, isLoading } = useSelector((s: any) => s.rmStore);

    // `filters` is what the user is typing; `searchCriteria` is what has
    // actually been searched for. Only Search / Clear / pagination move one
    // into the other.
    const [filters, setFilters] = useState({ ...EMPTY_FILTERS } as any)
    const [searchCriteria, setSearchCriteria] = useState({
        pageNumber: 0,
        pageSize: GET_REVIEWS_DEFAULT_SIZE,
        ...EMPTY_FILTERS,
    } as any)

    useEffect(() => {
        const { fromDate, toDate, ...rest } = searchCriteria;
        // The date inputs give yyyy-mm-dd; the API takes epoch millis.
        const payload = {
            ...rest,
            fromDate: fromDate ? new Date(fromDate).getTime() : "",
            toDate: toDate ? new Date(toDate).getTime() : "",
        };
        dispatch(getReviews(queryString.stringify(removeEmptyStringKeys(payload)), null));
    }, [searchCriteria, dispatch]);

    const onFilterChange = (key: string, value: string) => {
        setFilters({ ...filters, [key]: value });
    };

    const hasActiveFilters = Object.keys(EMPTY_FILTERS)
        .some((key) => !!filters[key] || !!searchCriteria[key]);

    // A new search always starts from the first page — keeping the old page
    // number would land the user on an empty tail of a shorter result set.
    const onSearch = () => {
        setSearchCriteria({ ...searchCriteria, ...filters, pageNumber: 0 });
    };

    const clearFilters = () => {
        setFilters({ ...EMPTY_FILTERS });
        setSearchCriteria({ ...searchCriteria, ...EMPTY_FILTERS, pageNumber: 0 });
    };

    // CommonPagination counts pages from 1, the API counts them from 0.
    const onPageChange = (pageNumber: any) => {
        setSearchCriteria({ ...searchCriteria, pageNumber: Math.max(0, Number(pageNumber) - 1) })
    }

    return (
        <>
            <ReviewFilters
                filters={filters}
                onFilterChange={onFilterChange}
                onSearch={onSearch}
                clearFilters={clearFilters}
                hasActiveFilters={hasActiveFilters}
            />
            <div className="mt-2.5 campaign-list bg-white mb-[54px]">
                <table className="w-full">
                    <thead className="bg-[#343434]">
                        <tr>
                            {REVIEW_PAGE_HEADERS?.map((header: string) => (
                                <th key={header} scope="col" className="px-4 py-3 text-left text-xs font-semibold text-white whitespace-nowrap">
                                    {header}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading ? (
                            <tr>
                                <td colSpan={REVIEW_PAGE_HEADERS.length} className="py-12">
                                    <div className="flex flex-col items-center justify-center space-y-2">
                                        <Loader />
                                        <span className="text-xs text-gray-500">Loading reviews...</span>
                                    </div>
                                </td>
                            </tr>
                        ) : !reviews?.data?.length ? (
                            <tr>
                                <td colSpan={REVIEW_PAGE_HEADERS.length} className="px-4 py-12 text-center text-xs text-gray-500">
                                    No reviews found.
                                </td>
                            </tr>
                        ) : (
                            reviews.data.map((item: any, index: number) =>
                                <ReviewModerationItem key={item.id ?? index} index={index} review={item} />
                            )
                        )}
                    </tbody>
                </table>
            </div>
            {reviews?.data && (
                <CommonPagination
                    data={reviews}
                    PAGE_SIZE={GET_REVIEWS_DEFAULT_SIZE}
                    onPageChange={onPageChange}
                />
            )}
        </>
    )
}

export default ReviewList
